import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './LoginPage.css';

const baseEnvironment = process.env.REACT_APP_API_BASE_URL?.trim() || 'http://localhost:8010';
const API_BASE_URL = baseEnvironment.replace(/\/$/, '');
const APP_LOGO_SRC = `${process.env.PUBLIC_URL || ''}/Rationexus-Logo.png`;

const normalizeRoleName = (rawRole) => {
  const raw = (rawRole || '').trim();
  if (!raw) {
    return '';
  }
  const canonical = raw.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
  if (canonical === 'SYSADMIN') {
    return 'SYS_ADMIN';
  }
  if (canonical === 'TENANTADMIN') {
    return 'TENANT_ADMIN';
  }
  if (canonical === 'TENANTUSER') {
    return 'TENANT_USER';
  }
  return raw.toUpperCase();
};

function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const justActivated = Boolean(location.state?.activated);

  useEffect(() => {
    if (sessionStorage.getItem('authToken')) {
      navigate('/home', { replace: true });
    }
  }, [navigate]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setCredentials((current) => ({ ...current, [name]: value }));
  };

  const submitLogin = async (event) => {
    event.preventDefault();
    setError('');
    setIsSubmitting(true);

    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(credentials),
      });

      if (!response.ok) {
        const payload = await response.json().catch(() => null);
        throw new Error(payload?.message ?? 'Giriş başarısız (kullanıcı adı veya şifre yanlış).');
      }

      const data = await response.json();
      sessionStorage.setItem('authToken', data.token);
      sessionStorage.setItem('authRefreshToken', data.refreshToken || '');
      sessionStorage.setItem('authUsername', data.username);
      sessionStorage.setItem('authRole', normalizeRoleName(data.role));
      sessionStorage.setItem('authTenantUserMode', data.tenantUserMode || '');
      navigate('/home', { replace: true });
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : 'Giriş sırasında bir hata oluştu.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const isFormValid = credentials.username.trim() && credentials.password.trim();

  return (
    <div className="auth-page">
      <div className="auth-card">
        <img src={APP_LOGO_SRC} alt="RatioNexus" className="auth-logo" />
        <h1>RatioNexus</h1>
        <p className="subtitle">Sisteme giriş</p>
        {justActivated && (
          <p className="subtitle" style={{ color: '#86efac' }}>
            Hesabınız aktifleştirildi, giriş yapabilirsiniz.
          </p>
        )}
        <form onSubmit={submitLogin}>
          <label>
            Kullanıcı adı
            <input
              name="username"
              autoComplete="username"
              value={credentials.username}
              onChange={handleChange}
            />
          </label>
          <label>
            Şifre
            <input
              type="password"
              name="password"
              autoComplete="current-password"
              value={credentials.password}
              onChange={handleChange}
            />
          </label>
          <button type="submit" disabled={!isFormValid || isSubmitting}>
            {isSubmitting ? 'Giriş yapılıyor…' : 'Giriş'}
          </button>
        </form>
        <p className="error">{error || 'Veritabanındaki kullanıcı ile giriş yapabilirsiniz.'}</p>
      </div>
    </div>
  );
}

export default LoginPage;
